import { DateTimeNativeHtml5PickerComponent } from './date-time-native-html5-picker.component';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeModule } from 'primeng/tree';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    DateTimeNativeHtml5PickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule
  ],
  exports:[
    DateTimeNativeHtml5PickerComponent
  ]
})
export class DateTimeNativeHtml5PickerModule { }
